import { Injectable } from '@angular/core';
import { AngularFire } from 'angularfire2';
import { AuthData } from '../providers/auth';
import { Utilities } from '../providers/utilities';
import { EventData } from '../providers/event';
import { Database } from '../providers/database';
import * as firebase from 'firebase';

@Injectable()

export class QuestionsData {
  listenerController: any;

  constructor(public af: AngularFire, public auth: AuthData, public ut: Utilities, public db: Database, public eventProvider: EventData) {
  }

  getConfigQuestion(client: any, token_event, token_diary) {
    let q = this.eventProvider.getSingleData(client, token_event, 'QuestionConfig/' + token_diary);

    return new Promise((resolve, reject) => {
      q.then((snapshot) => {
        resolve(snapshot);
      }).catch(error => {
        reject(error);
      })
    })
  }

  getListQuestions(client: any, token_event, token_diary, allUsers) {
    if (allUsers) {
        return this.af.database.list('/Clients/' + client.url + '/Events/' + token_event + '/Question/' + token_diary);
    } else {
      if (this.auth.getUser()) {
        return this.af.database.list('/Clients/' + client.url + '/Events/' + token_event + '/Question/' + token_diary, {
          query: {
            orderByChild: 'uid',
            equalTo: this.auth.getUser().uid
          }
        });
      }
    }
  }

  getMyLike(client: any, tokenEvent: string, tokenDiary: string, tokenQuestion: string) {
    const q = firebase.database().ref().child('/Clients/' + client.url + '/___likesQuestion/' + tokenEvent + '/' + tokenDiary + '/' + tokenQuestion + '/' + this.auth.getUser().uid);

    return new Promise((resolve, reject) => {
      q.once('value', (snapshot) => {
        resolve(snapshot);
      }).catch((error) => {
        reject(error)
      });
    });
  }

  pushLike(client: any, tokenEvent, tokenDiary, tokenQuestion) {
    let obj = {
      tokenQuestion: tokenQuestion,
      uid: this.auth.getUser().uid,
      email: this.auth.getUser().email || 'Anonymous',
      timestamp: new Date().getTime(),
    };

    return new Promise((resolve, reject) => {
      this.db.pushDatakey('/Clients/' + client.url + '/___likesQuestion/' + tokenEvent + '/' + tokenDiary + '/' + tokenQuestion, obj, this.auth.getUser().uid)
      .then(() => {
        // Increase counter
        firebase.database().ref().child('/Clients/' + client.url + '/Events/' + tokenEvent + '/Question/' + tokenDiary + '/' + tokenQuestion + '/numLikes').
        transaction((currentCount) => {
          return currentCount + 1;
        });

        resolve(true);
      })
      .catch((error) => {
        reject(error);
      });
    });
  }

  create(client: any, dataObject: any, token_event, token_diary) {
    dataObject.uid = this.auth.getUser().uid;
    dataObject.email = this.auth.getUser().email || 'Anonymous';
    dataObject.timestamp = new Date().getTime();

    return this.db.pushData('/Clients/' + client.url + '/Events/' + token_event + '/Question/' + token_diary, dataObject);
  }
}
// end file



// WEBPACK FOOTER //
// ./src/providers/questions.ts